const SUFFIX = ['DEFAULT', '5', '6', '7', 'contrast', 'complement'] as const;

const FALLBACK = {
  DEFAULT: '#0081f9',
  1: '#9ED0FE',
  2: '#77BCFD',
  3: '#4FA9FB',
  4: '#2895FA',
  5: '#0081F9',
  6: '#006CD0',
  7: '#0057A7',
  8: '#00417F',
  9: '#002C56',
  contrast: '#ffffff',
  complement: '#000000',
};

const generateVariableName = (name: string, suffix: string) =>
  suffix === 'DEFAULT' ? `--${name}` : `--${name}-${suffix}`;

export const generateConfig = (name: string) =>
  SUFFIX.reduce((config, suffix) => {
    config[suffix] = `rgb(var(${generateVariableName(name, suffix)}, ${
      FALLBACK[suffix]
    }) / <alpha-value>)`;
    return config;
  }, {} as typeof FALLBACK);
